/**
 * @generated SignedSource<<bb40e2cb565f30dda172ea438cf4970b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type boardPage_GenerateBoardReportMutation$variables = Record<PropertyKey, never>;
export type boardPage_GenerateBoardReportMutation$data = {
  readonly generateBoardReport: {
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type boardPage_GenerateBoardReportMutation = {
  response: boardPage_GenerateBoardReportMutation$data;
  variables: boardPage_GenerateBoardReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "boardPage_GenerateBoardReportMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateBoardReportMutationPayload",
        "kind": "LinkedField",
        "name": "generateBoardReport",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "boardPage_GenerateBoardReportMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateBoardReportMutationPayload",
        "kind": "LinkedField",
        "name": "generateBoardReport",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32362321673f0cab3005098ca475a7ca",
    "id": null,
    "metadata": {},
    "name": "boardPage_GenerateBoardReportMutation",
    "operationKind": "mutation",
    "text": "mutation boardPage_GenerateBoardReportMutation {\n  generateBoardReport {\n    enqueued\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c32dbc9448ec89f532b71197f8a2bf3f";

export default node;
